import React from 'react';
// styles
import styled, { css } from 'styled-components';
import { gridSizes, media } from 'utils/style';

const regularCSS = css`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  /* prettier-ignore */
  -ms-grid-columns: ${gridSizes('M')} (1fr)[12];
  grid-gap: ${gridSizes('M')};
  grid-template-rows: none;
  flex: 1;
  width: 100%;
  max-width: 1094px;
  margin: 0 auto;
`;

const mobileCSS = `
    padding: 0 10px;
    grid-template-columns: repeat(6, 1fr);
    /* prettier-ignore */
    -ms-grid-columns: ${gridSizes('M')} (1fr ${gridSizes('M')})[6];
`;

const Main = styled.main`
  ${regularCSS}
  ${media.lessThan('extraSmall')`${mobileCSS}`}
`;

export default React.memo(Main);
